import { gql } from '@grandvisionhq/graphql';

const OptInFragment = gql`
  fragment OptInFragment on OptIn {
    id
    literalText
    uiType
    value
    __typename
  }
`;
const OptInsFragment = gql`
  fragment OptIns on Customer {
    optIns {
      ...OptInFragment
    }
  }
  ${OptInFragment}
`;
var GET_OPT_INS = gql`
  query getOptIns {
    me {
      id
      ...OptIns
      __typename
    }
  }
  ${OptInsFragment}
`;

export { GET_OPT_INS as default };
//# sourceMappingURL=get-opt-ins.js.map
